import { wsScanToMap, type ABORMarketAccountApiPermissionFilter, type MinimalSubscriptionResponse } from '@talos/kyoko';
import { map, merge, type Observable } from 'rxjs';

export type ABORMarketAccountPermissionFiltersState = {
  aborMarketAccountPermissionFiltersByFilterID: Map<string, ABORMarketAccountApiPermissionFilter>;
  aborMarketAccountFilterIDsBySubAccountName: Map<string, Set<string>>;
};

/** Rebuild the subaccount index from the current FilterID map so both stay in lockstep. */
export function buildFilterIDsBySubAccountName(
  permissionsByFilterID: Map<string, ABORMarketAccountApiPermissionFilter>
): Map<string, Set<string>> {
  const filterIDsBySubAccountName = new Map<string, Set<string>>();

  for (const [filterID, permission] of permissionsByFilterID) {
    const subAccount = permission.Subject.SubAccount;
    if (!subAccount) {
      continue;
    }

    const filterIDs = filterIDsBySubAccountName.get(subAccount) ?? new Set<string>();
    filterIDs.add(filterID);
    filterIDsBySubAccountName.set(subAccount, filterIDs);
  }

  return filterIDsBySubAccountName;
}

export function observeABORMarketAccountPermissionFilters(
  rawObs: Observable<MinimalSubscriptionResponse<ABORMarketAccountApiPermissionFilter>>,
  updatesObs: Observable<MinimalSubscriptionResponse<ABORMarketAccountApiPermissionFilter>>
): Observable<ABORMarketAccountPermissionFiltersState> {
  return merge(rawObs, updatesObs).pipe(
    wsScanToMap({
      getUniqueKey: permission => permission.FilterID,
      newMapEachUpdate: true,
    }),
    map(permissionsByFilterID => ({
      aborMarketAccountPermissionFiltersByFilterID: permissionsByFilterID,
      aborMarketAccountFilterIDsBySubAccountName: buildFilterIDsBySubAccountName(permissionsByFilterID),
    }))
  );
}
